import { CobaltSidePanelContainer } from '@cae/cobalt-react/components/side-panel';
import { InvoiceAlertPanel } from '@features/invoices/components/alert-panel/InvoiceAlertPanel';
import { InvoicesContent } from '@features/invoices/components/content/InvoicesContent';
import { InvoicesHeader } from '@features/invoices/components/header/InvoicesHeader';
import styles from '@features/invoices/components/invoices-page-content/InvoicesPageContent.module.css';
import { useInvoiceAlertsData } from '@features/invoices/contexts/alerts/useInvoiceAlertsData';
import * as React from 'react';

const InvoicesPageContent = React.memo((): React.ReactElement => {
  const { selectedAlert, closeAlertPanel } = useInvoiceAlertsData();

  return (
    <CobaltSidePanelContainer
      className={styles.invoicesPage}
      data-testid="invoices-page"
      content={
        <>
          <InvoicesHeader />
          <div className={styles.pageContent}>
            <InvoicesContent />
          </div>
        </>
      }
      sidePanel={
        selectedAlert ? (
          <InvoiceAlertPanel
            alert={selectedAlert}
            isOpen
            onClose={closeAlertPanel}
          />
        ) : undefined
      }
    />
  );
});

InvoicesPageContent.displayName = 'InvoicesPageContent';
export { InvoicesPageContent };
